import { ClientConfigInit as _ClientConfigInit } from './src/client';
export type ClientConfigInit = _ClientConfigInit;

export {
  AppId,
  appId,
  dontUpsell,
  dontDismissNotifications,
  limitMemoryUsage,
  desktopVersion,
} from './src/client';
export {
  slackDomain,
  slackTrelloDomain,
  trelloForWebsites,
  customFieldsId,
  firstPartyPluginsOrg,
  listLimitsPowerUpId,
  mapPowerUpId,
  bitbucketPowerUpId,
  attachmentsDomain,
  avatarDomain,
  backgroundDomain,
  logoDomain,
  oneDriveClientId,
  googleDriveClientId,
  dropboxClientAppKey,
  boxClientId,
  braintreeClientToken,
  googleMapsApiKey,
  snowplowCloudfrontServer,
  analyticsWebClientEnv,
  analyticsWebClientApiHost,
  launchdarklyKey,
  appcuesAccountId,
  client,
  clientVersion,
  locale,
  aaManagedProfileUrl,
  aaManageRecentDevicesUrl,
  siteDomain,
  atlassianApiGateway,
  wacUrl,
  certcaptureGencertUrl,
} from './src/globals';
